import { useEffect, useState } from "react";
import { getPoItem } from "src/services/po-api";
import { useToast } from "src/hooks/useToast";
import { Spinner } from "src/components";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

const PoGeneration = ({ orderProductId, company_code, item_code }: any) => {
  const [poDetails, setPoDetails] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
  const orderDetails = orderDetailsFiltered?.[0];
  const isSao = orderDetails?.cndn_remarks_code_int === 2;

  const { toast } = useToast();

  console.log("itemcode", item_code);

  const fetchPoDetails = async () => {
    setIsLoading(true);
    let payload;
    if(isSao) {
      payload = {
        item_code: item_code,
        company_code: company_code,
        po_generatetype: "SAO",
        order_id: orderDetails?.order_id_int,
      }
    } else {
      payload = {
        order_product_id: orderProductId,
        company_code: company_code,
      }
    }
    try {
      const response = await getPoItem(payload);
      setPoDetails(orderDetails?.cndn_remarks_code_int === 2 ? [response?.data?.data?.poItems] : response?.data?.data?.invoiceProductMappings);
    } catch (error: any) {
      console.log(error);
      toast({
        title: "Error",
        description: error?.response?.data?.message || "Something went wrong",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPoDetails();
  }, [orderProductId]);

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center">
          <Spinner size="small" />
        </div>
      ) : poDetails?.length > 0 ? (
        <div className="overflow-x-scroll">
          <table className="min-w-full mt-2 border">
            <thead className="w-full">
              <tr>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Number</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Date</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Item Code</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Plant Code</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Company Stockist Code</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Quantity</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Free Quantity</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Amount</th>
              </tr>
            </thead>
            <tbody>
              {poDetails?.map((item: any) => (
                <tr key={item?.invoice_product_order_product_id} className="text-sm">
                  <td className="px-4 py-1 text-[.8rem] border">{ isSao ? item?.purchaseOrder?.po_number : item?.po_item?.purchaseOrder?.po_number}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{moment(isSao ? item?.purchaseOrder?.created_date :   item?.po_item?.purchaseOrder?.created_date).format("DD-MM-YYYY h:mm a")}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{isSao ? item?.item_code_po : item?.po_item?.item_code_po}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{isSao ? item?.plant_code : item?.po_item?.plant_code}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{isSao ? item?.purchaseOrder?.compStockistAliasCode : item?.po_item?.purchaseOrder?.compStockistAliasCode}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{isSao ? item?.invoiced_qty : item?.po_item?.final_qty}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{isSao ? item?.invoiced_free_qty : item?.po_item?.invoiced_free_qty}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{isSao ? item?.line_amount : item?.po_item?.line_amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="mt-2 text-center text-sm text-[#B5B5B5]">No data found</div>
      )}
    </div>
  );
};

export default PoGeneration;
